module.exports = __webpack_public_path__ + "img/concert.b970dbb1.png";